import { Subject } from "rxjs"

// private module logic //

const versionStream = new Subject<object>()

function newVersion(version: object): void {
  versionStream.next(version)
}

// public module interface //

const versionService = {
  stream: () => versionStream.asObservable(),
  newVersion: (version: object) => newVersion(version)
}

export default versionService
